import { format, differenceInYears, startOfDay, isSameDay, subDays, parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export function formatTime(date: string, inputFormat = `yyyy-MM-dd'T'HH:mm:ssXXX`, outputFormat = 'HH:mm') {
	try {
		const dateObject = parseISO(date)
		return format(dateObject, outputFormat)
	} catch (error) {
		return null
	}
}

export function formatDate(date: string, inputFormat = `yyyy-MM-dd'T'HH:mm:ssXXX`, outputFormat = 'dd.MM.yyyy') {
	try {
		const dateObject = parseISO(date)
		return format(dateObject, outputFormat)
	} catch (error) {
		return null
	}
}

export function formatTimeMenu(inputTime: string) {
	const today = startOfDay(new Date())
	const yesterday = subDays(today, 1)
	const inputDate = parseISO(inputTime)

	if (isSameDay(inputDate, today)) {
		return format(inputDate, "HH:mm")
	} else if (isSameDay(inputDate, yesterday)) {
		return 'Včera'
	} else {
		return format(inputDate, "dd.MM.yyyy ")
	}
}

export function formatUtcToLocalTimezone(date: string, outputFormat = 'dd.MM.yyyy') {
    try {
        const dateObject = parseISO(date)
        const dateInLocalTimezone = utcToZonedTime(dateObject, Intl.DateTimeFormat().resolvedOptions().timeZone)
        return format(dateInLocalTimezone, outputFormat)
    } catch (error) {
        return null
    }
}